@if (node$ | async; as node) {
    @if (node.openInNewTab) {
        @if (url$ | async; as url) {
            <a class="navigation-node-text"
               [attr.href]="node.url"
               target="_blank"
               rel="noreferrer noopener"
               [title]="node.title"
               [ngClass]="{ 'navigation-node-link': !!url }">
                <ng-container *ngTemplateOutlet="showNodeContent"></ng-container>
            </a>
        } @else {
            <span class="navigation-node-text">
                <ng-container *ngTemplateOutlet="showNodeContent"></ng-container>
            </span>
        }
    } @else {
        @if (url$ | async; as url) {
            <a class="navigation-node-text"
               (click)="onNodeClicked(node)"
               [ngClass]="{ 'navigation-node-link': !!url }"
               [routerLink]="url?.path"
               [queryParams]="url?.queryParams"
               [state]="currentState">
                <ng-container *ngTemplateOutlet="showNodeContent"></ng-container>
            </a>
        } @else {
            <span class="navigation-node-text">
                <ng-container *ngTemplateOutlet="showNodeContent"></ng-container>
            </span>
        }
    }
    <ng-template #showNodeContent>
        @if (node?.iconPositionRight && node?.title; as title) {
            <span class="text-capitalize"
                  [ngClass]="{ 'me-1': !isInBreadcrumb }">{{ title }}</span>
        }
        @if ((!isInBreadcrumb || !node?.hideIconInBreadcrumb) && node?.iconClass; as iconClass) {
            <i [ngClass]="iconClass + (isInBreadcrumb ? ' me-1' : '')"></i>
        }
        @if (!node?.iconPositionRight && node?.title; as title) {
            <span class="text-capitalize">{{ title }}</span>
        }
    </ng-template>
}
